import { atom } from "recoil";

export const homeSaleData = atom({
  key: 'homeSaleData',
  default: ''
})

export const homeOrderData = atom({
    key: 'smr_companyLogoM',
    default: ''
  })

  export const homeoutrStandData = atom({
    key: 'homeoutrStandData',
    default: ''
  })

  export const homeFgStockData = atom({
    key: 'homeFgStockData',
    default: ''
  })


  export const homeChartData = atom({
    key: 'homeChartData',
    default: ''
  })


  export const homeRawMaterialData = atom({
    key: 'homeRawMaterialData',
    default: ''
  })


  export const menuDrawer = atom({
    key: 'menuDrawer',
    default: false
  })


    export const scannerActive = atom({
    key: 'scannerActive',
    default: "scanner"
  })
